import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import {
	getFromEmailsSuccess,
	getFromEmailsFailed,
	getToEmailsSuccess,
	getToEmailsFailed,
	getUsersSuccess,
	getUsersFailed,
	getSourcesSuccess,
	getSourcesFailed,
	getRetainFiltersSuccess,
	getRetainFiltersFailed,
	getInfoSuccess,
	getInfoFailed,
	getReviewOverviewDetailsSuccess,
	getReviewOverviewDetailsFailed,
	getUserReviewOverviewDetailsFailed,
	getUserReviewOverviewDetailsSuccess,
	getDynamicFromEmailsSuccess,
	getDynamicFromEmailsFailed,
	getDynamicToEmailsSuccess,
	getDynamicToEmailsFailed,
} from "../actions/infoActions"
import {
	GET_FROM_EMAILS_LIST_REQUEST,
	GET_TO_EMAILS_LIST_REQUEST,
	GET_SOURCES_LIST_REQUEST,
	GET_RETAIN_FILTERS_LIST_REQUEST,
	GET_INFO,
	GET_REVIEW_OVERVIEW_DETAILS_REQUEST,
	GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST,
} from "../types/index"
import { history } from "../helpers/history"
import { infoService } from "../services/info.services"

import { GET_EMAILS_LIST_REQUEST, GET_USERS_LIST_REQUEST } from "../types/index"
import { setNotification } from "../actions/notificationActions"
import { payloadParsing } from "../utils"

/****************Ragnar Lodbrok****************/
function* getFromEmailsListSaga(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getEmailsList, "from")
		if (result.status === 200 && result.data.success === true) {
			yield put(getFromEmailsSuccess(result?.data?.info?.metadata_distinct?.from))
		} else {
			yield put(getFromEmailsFailed(result))
		}
	} catch (error) {
		yield put(getFromEmailsFailed(error))
	}
}

function* getToEmailsListSaga(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getEmailsList, "to")
		if (result.status === 200 && result.data.success === true) {
			yield put(getToEmailsSuccess(result?.data?.info?.metadata_distinct?.to))
		} else {
			yield put(getToEmailsFailed(result))
		}
	} catch (error) {
		yield put(getToEmailsFailed(error))
	}
}

function* getUsersSaga(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getUserList, data)

		if (result.status === 200 && result.data.success === true) {
			yield put(getUsersSuccess(result?.data?.info))
		} else {
			yield put(getUsersFailed(result))
		}
	} catch (error) {
		yield put(getUsersFailed(error))
	}
}

function* getSourcesListSaga(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getSourcesList)
		if (result.status === 200 && result.data.success === true) {
			yield put(getSourcesSuccess(result?.data?.info?.metadata_distinct?.source))
		} else {
			yield put(getSourcesFailed(result))
		}
	} catch (error) {
		yield put(getSourcesFailed(error))
	}
}

function* getRetainFilterDataFromJob(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getRetainFilterListFromJob, data)
		if (result.status === 200 && result.data.success === true) {
			yield put(getRetainFiltersSuccess(result?.data?.job?.search_request))
		} else {
			// yield put(
			// 	setNotification({
			// 		data: result?.data?.message || "something went wrong",
			// 		severity: "error",
			// 	})
			// )
			yield put(getRetainFiltersFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(
			setNotification({
				data: error?.message || "something went wrong",
				severity: "error",
			})
		)
		yield put(getRetainFiltersFailed(error))
	}
}

function* getInfoSaga() {
	try {
		const result = yield call(infoService.getInfo)
		if (result.status === 200 && result.data.success === true) {
			yield put(getInfoSuccess(result?.data?.info))
		} else {
			yield put(getInfoFailed(result))
		}
	} catch (error) {
		yield put(getInfoFailed(error))
	}
}

function* getReviewOverviewSaga(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getReviewOverview, data)
		if (result.status === 200 && result.data.success === true) {
			yield put(getReviewOverviewDetailsSuccess(result?.data?.data))
		} else {
			yield put(getReviewOverviewDetailsFailed(result))
		}
	} catch (error) {
		yield put(getReviewOverviewDetailsFailed(error))
	}
}

function* getUserReviewOverviewSaga(action) {
	try {
		const data = action.payload
		const result = yield call(infoService.getUserReviewOverview, data)
		if (result.status === 200 && result.data.success === true && result?.data?.data?.review_overview?.length) {
			yield put(getUserReviewOverviewDetailsSuccess(result?.data?.data))
		} else {
			yield put(getUserReviewOverviewDetailsFailed(result))
		}
	} catch (error) {
		yield put(getUserReviewOverviewDetailsFailed(error))
	}
}

function* getDynamicFromEmailsListSaga(action) {
	try {
		const data = payloadParsing(action.payload)
		const result = yield call(infoService.getDynamicEmailsList, { ...data, metadata_field: "from" }, "from")
		if (result.status === 200 && result.data.success === true) {
			yield put(getDynamicFromEmailsSuccess(result?.data))
		} else {
			yield put(getDynamicFromEmailsFailed(result))
		}
	} catch (error) {
		yield put(getDynamicFromEmailsFailed(error))
	}
}

function* getDynamicToEmailsListSaga(action) {
	try {
		const data = payloadParsing(action.payload)
		const result = yield call(infoService.getDynamicEmailsList, { ...data, metadata_field: "to" }, "to")
		if (result.status === 200 && result.data.success === true) {
			yield put(getDynamicToEmailsSuccess(result?.data))
		} else {
			yield put(getDynamicToEmailsFailed(result))
		}
	} catch (error) {
		yield put(getDynamicToEmailsFailed(error))
	}
}

function* infoWatcher() {
	yield takeLatest(GET_FROM_EMAILS_LIST_REQUEST, getFromEmailsListSaga)
	yield takeLatest(GET_TO_EMAILS_LIST_REQUEST, getToEmailsListSaga)
	yield takeLatest(GET_USERS_LIST_REQUEST, getUsersSaga)
	yield takeLatest(GET_SOURCES_LIST_REQUEST, getSourcesListSaga)
	yield takeLatest(GET_RETAIN_FILTERS_LIST_REQUEST, getRetainFilterDataFromJob)
	yield takeLatest(GET_INFO, getInfoSaga)
	yield takeLatest(GET_REVIEW_OVERVIEW_DETAILS_REQUEST, getReviewOverviewSaga)
	yield takeLatest(GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST, getUserReviewOverviewSaga)
	yield takeLatest(GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST, getDynamicFromEmailsListSaga)
	yield takeLatest(GET_DYNAMIC_TO_EMAILS_LIST_REQUEST, getDynamicToEmailsListSaga)
}

export default infoWatcher
